import { FC, PropsWithChildren, useMemo } from 'react';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { Helmet } from 'react-helmet-async';
import { RTL } from 'src/components/rtl';
import { useSettingsContext, useTenantContext } from 'src/hooks/use-context';
import { createTheme } from '.';

/**
 * Provide Material UI theme from settings and tenant information
 */
export const Theme: FC<PropsWithChildren> = (props) => {
  const { children } = props;

  // tenant theme settings
  const { style } = useTenantContext();
  const { settings } = useSettingsContext();

  const theme = useMemo(
    () =>
      createTheme({
        tenantPalette: style.palette,
        contrast: 'normal',
        direction: 'ltr',
        paletteMode:
          // TODO: detect system color mode
          settings.colorMode === 'dark' ? 'dark' : 'light',
        responsiveFontSizes: true
      }),
    [style, settings]
  );

  return (
    <ThemeProvider theme={theme}>
      <Helmet>
        <meta
          name="color-scheme"
          content={theme.palette.mode}
        />
        <meta
          name="theme-color"
          content={theme.palette.primary.main}
        />
      </Helmet>
      <RTL direction={theme.direction}>
        <CssBaseline />
        {children}
      </RTL>
    </ThemeProvider>
  );
};
